import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Activity, LogIn, LogOut, Navigation } from "lucide-react";

export const LiveOpsTab = () => {
  const [stats, setStats] = useState({ activeNow: 0, checkedInToday: 0, checkedOutToday: 0, etaInFlight: 0 });

  useEffect(() => {
    const load = async () => {
      const now = new Date().toISOString();
      const todayStart = new Date(); todayStart.setHours(0, 0, 0, 0);
      const tIso = todayStart.toISOString();

      const [a, b, c, d] = await Promise.all([
        supabase.from("bookings").select("*", { count: "exact", head: true }).lte("start_time", now).gte("end_time", now).eq("status", "confirmed"),
        supabase.from("bookings").select("*", { count: "exact", head: true }).gte("checked_in_at", tIso),
        supabase.from("bookings").select("*", { count: "exact", head: true }).gte("checked_out_at", tIso),
        supabase.from("booking_eta_updates").select("*", { count: "exact", head: true }).gte("updated_at", new Date(Date.now() - 30 * 60_000).toISOString()),
      ]);
      setStats({
        activeNow: a.count || 0,
        checkedInToday: b.count || 0,
        checkedOutToday: c.count || 0,
        etaInFlight: d.count || 0,
      });
    };
    load();
    const t = setInterval(load, 30_000);
    return () => clearInterval(t);
  }, []);

  const cards = [
    { label: "Active bookings now", value: stats.activeNow, icon: Activity },
    { label: "Check-ins today", value: stats.checkedInToday, icon: LogIn },
    { label: "Check-outs today", value: stats.checkedOutToday, icon: LogOut },
    { label: "ETAs (last 30 min)", value: stats.etaInFlight, icon: Navigation },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((c) => (
        <Card key={c.label}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <CardTitle className="text-sm font-medium">{c.label}</CardTitle>
            <c.icon className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-3xl font-bold">{c.value}</div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
